import React from 'react';
import formatNumber from "../../helpers/NumberFormat";
import { useNavigate } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa6";
import "./HomeClientNew.scss"

export default function AccountSummary({ main }) {
  const navigate = useNavigate();
  const user = main?.user;

  return (
    <div className="card-section next-payments-box d-flex flex-column"
      style={{ borderBottom: "2px solid #EFEFEF" }}>
      <h5>Account Summary</h5>
      <div className="card-section mt-2" style={{ height: '100px' }}>
        <div className="border-new w-100">
          <div>
            <h5>{user?.first_name} {user?.last_name}</h5>
          </div>
          <div>
            <span className="account-number"> Current Account: {user?.detail?.account_number?.replace(/^.*?-/, '')}</span>
          </div>
        </div>
      </div>
      <div className='bg-custom-light p-3 d-flex flex-column justify-content-between mt-3'>
        <p className="account-number mb-0">IBAN coordinates</p>
        <span className='text-muted-custom' style={{ fontSize: "20px", marginTop: "2px" }}>{user?.detail?.iban}</span>
      </div>

      <div className="balance-wrapper mt-3">
        <div className="balance-row">
          <span>Available Balance:</span>
          <strong>{formatNumber(main?.user?.balance)} €</strong>
        </div>
        <div className="balance-row">
          <span>Accounting Balance:</span>
          <strong>{formatNumber(main?.user?.balance)} €</strong>
        </div>
        <div className="balance-row">
          <span>Overdraft:</span>
          <strong>{formatNumber(0)} €</strong>
        </div>
        <div className="balance-row">
          <span>Interest and fees:</span>
          <strong>{formatNumber(0)} €</strong>
        </div>
      </div>

      <div className='homeLinks mt-4'>
        <a onClick={() => navigate('/balance-and-movements')}>BALANCE AND MOVEMENTS <FaAngleRight /></a>
      </div>
    </div>
  );
}